import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import RadioOff from '../Icons/RadioOff';
import RadioOn from '../Icons/RadioOn';
import Paragraph from '../Paragraph/Paragraph';

const RadioContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 8px;
  position: relative;
  width: auto;
  max-width: max-content;
  cursor: pointer;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  margin-bottom: ${(props) => (props.mb ? `${props.mb}px` : 0)};
  margin-top: ${(props) => (props.mt ? `${props.mt}px` : 0)};
`;

const RadioIconContainer = styled.div`
  margin-top: 2px;
`;

const Label = styled(Paragraph)``;

const Radio = React.memo(
  ({ label, selected, isBold, LabelPostfix, dataCy, ...props }) => (
    <RadioContainer {...props}>
      <RadioIconContainer data-cy={dataCy}>
        {selected ? <RadioOn /> : <RadioOff />}
      </RadioIconContainer>

      {label && (
        <Label weight={selected && isBold ? 600 : 400}>
          {label} {!!LabelPostfix && <LabelPostfix />}
        </Label>
      )}
    </RadioContainer>
  ),
);

Radio.propTypes = {
  label: PropTypes.string,
  selected: PropTypes.bool,
  isBold: PropTypes.bool,
  dataCy: PropTypes.string,
  LabelPostfix: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.string,
    PropTypes.shape({ render: PropTypes.func.isRequired }),
  ]),
};

Radio.defaultProps = {
  isBold: false,
};

export default Radio;
